//rp1011

import { controls } from "../../controls";

const rp1012 = {
  label: "MOU 11",
  pageLabel: "MOU 11",
  starting: true,
  url: "rp1012",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [
  
  
  
  
    ...controls.displayText({tab: "filter",label: "As On Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "As On Date Last Yr", star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date_last_yr_date",width:"col-sm-2"}),



    
 //   ...controls.magicDateLabel({ tab: "Modal", label: "As on Date",star:true, width: "col-sm-2" }),
   // ...controls.magicDate({ tab: "Modal", isRequired:true,name: "date_to_dueration", width: "col-sm-2", convertedTo:"return_duration",dateType:"ontype", }),
    //...controls.showData({tab:"Modal",data: "return_duration", name: "return_duration",width:"col-sm-2"}),


    //...controls.magicDateLabel({ tab: "Modal", label: "As on Date Last Yr.",star:true, width: "col-sm-2" }),
    //...controls.magicDate({ tab: "Modal", isRequired:true,name: "date_to_dueration", width: "col-sm-2", convertedTo:"return_duration",dateType:"ontype", }),
    //...controls.showData({tab:"Modal",data: "return_duration", name: "return_duration",width:"col-sm-2"}),
  ],

  form:[],

  history: {
    perPage: 10,
    reportHeader: "WORKING RESULTS",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    clickable: true, 
    displayColumns: [
      {
        Header: "Sr No.",
        accessor: "srno",
        //width: 180,
        rwidth: "*"
      },
      {
        Header: "Particulars",
        accessor: "particulars",
      //  width: 130,
        rwidth: "*"
      },
      {
        Header: "ABBR",
        accessor: "abbr",
        //width: 130,
       rwidth: "*"
      },
      {
        Header: "Amount1",
        accessor: "amount1",
        //width: 100,
        rwidth: "*"
      },
      {
        Header: "Amount2",
        accessor: "amount2",
       // width: 100,
        rwidth: "*"
      }
    ]
  }
};

export default rp1012;